import { kuferClient } from '@xver/libs/axios';

import {
    CreateDomainMappingRequest,
    CreateDomainMappingResponse,
    DeleteDomainMappingResponse,
    DomainMappingResponse,
    ListDomainMappingsResponse,
} from './model';

const ENDPOINTS = {
    LIST: (containerId: string) => `/v1/containers/${containerId}/domain-mappings`,
    CREATE: (containerId: string) => `/v1/containers/${containerId}/domain-mappings`,
    GET: (containerId: string, mappingId: string) =>
        `/v1/containers/${containerId}/domain-mappings/${mappingId}`,
    DELETE: (containerId: string, mappingId: string) =>
        `/v1/containers/${containerId}/domain-mappings/${mappingId}`,
};

export function listDomainMappings(containerId: string): Promise<ListDomainMappingsResponse> {
    return kuferClient.get(ENDPOINTS.LIST(containerId));
}

export function getDomainMapping(
    containerId: string,
    mappingId: string
): Promise<DomainMappingResponse> {
    return kuferClient.get(ENDPOINTS.GET(containerId, mappingId));
}

export function createDomainMapping(
    containerId: string,
    data: CreateDomainMappingRequest
): Promise<CreateDomainMappingResponse> {
    return kuferClient.post(ENDPOINTS.CREATE(containerId), data);
}

export function deleteDomainMapping(
    containerId: string,
    mappingId: string
): Promise<DeleteDomainMappingResponse> {
    return kuferClient.delete(ENDPOINTS.DELETE(containerId, mappingId));
}
